import {Action} from "redux";
import {isType, AsyncActionCreators} from "typescript-fsa";

export function loadingReducer(actionCreators:
                                 AsyncActionCreators<any, any, any>) {
  return (state: boolean = false, action: Action): boolean => {
    if (isType(action, actionCreators.started)) {
      return true;
    }

    if (isType(action, actionCreators.done) ||
        isType(action, actionCreators.failed)) {
      return false;
    }

    return state;
  };
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/utils/reducers.ts